import { QuickButtonComplexContentType } from '../../../../../../components/quickButtonComplex/types/content';
import { QuickButtonComplexVariantType } from '../../../../../../components/quickButtonComplex/types/quickButtonComplex';
import { QuickButtonComplexState } from '../../../../../../components/quickButtonComplex/types/state';
import { disabledCommonStyles, secondaryCommonStyles } from '../commonStyles';
export const getSecondaryStyles = (FOUNDATIONS, FONT) => {
    return {
        [QuickButtonComplexVariantType.SECONDARY]: {
            [QuickButtonComplexContentType.WITH_ICON]: {
                [QuickButtonComplexState.DEFAULT]: {
                    ...secondaryCommonStyles(FOUNDATIONS, FONT),
                    icon: {
                        ...secondaryCommonStyles(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_default_icon,
                    },
                },
                [QuickButtonComplexState.PRESSED]: {
                    ...secondaryCommonStyles(FOUNDATIONS, FONT),
                    quickButtonComplex: {
                        ...secondaryCommonStyles(FOUNDATIONS, FONT).quickButtonComplex,
                        background_color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_pressed_bg,
                        border_color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_pressed_border,
                    },
                    icon: {
                        ...secondaryCommonStyles(FOUNDATIONS, FONT).icon,
                        color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_pressed_icon,
                    },
                    label: {
                        ...secondaryCommonStyles(FOUNDATIONS, FONT).label,
                        color: FOUNDATIONS.color_comp_actions_quickbutton_secondary_pressed_label,
                    },
                },
                [QuickButtonComplexState.DISABLED]: {
                    ...secondaryCommonStyles(FOUNDATIONS, FONT),
                    ...disabledCommonStyles(FOUNDATIONS, FONT),
                },
            },
        },
    };
};
//# sourceMappingURL=secondary.js.map